import React, { useState, useEffect } from 'react';
import { FaUser, FaProjectDiagram, FaListAlt,  FaRulerCombined,  FaInfoCircle } from 'react-icons/fa';
import Dashboard from '../../Admin/Dashboard';
import Weather from '../../Admin/Weather';
import IAProfiling from '../../Admin/ProfileSlide';
import IATraining from '../../Admin/TrainingSlide';
import styled from 'styled-components';
import bg1 from '../../Assets/bg/bg5.jpg';
import bg2 from '../../Assets/bg/Pilar.jpg';
import bg3 from '../../Assets/bg/SanMiguel.jpg';
import bg4 from '../../Assets/bg/Capayas.jpg';
import bg5 from '../../Assets/bg/Ubay.jpg';
import useIAProfileCounts from '../../Hooks/IAprofileHooks/useCountsIaProfile';
import useIATrainingCounts from '../../Hooks/IAtrainingHooks/useCountsIaTraining';
import useNISCounts from '../../Hooks/NisHooks/useCountsNIS';


const HomeNoso = ({darkMode}) => {
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const [showIAProfiling, setShowIAProfiling] = useState(false);
  const [showIATraining, setShowIATraining] = useState(false);
  const [showIMTContract, setShowIMTContract] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoTitle, setInfoTitle] = useState('');
  const [infoDescription, setInfoDescription] = useState('');
  const [selectedFarmer, setSelectedFarmer] = useState(null);


  const handleSelectFarmer = (farmer) => {
    setSelectedFarmer(farmer);
  };
  const { counts: profileCounts} = useIAProfileCounts(); 
  const { counts: trainingCounts} = useIATrainingCounts(); 
  const { counts: nisCounts} = useNISCounts();

  const images = [bg1, bg2, bg3, bg4, bg5];

  const [isSidebarExpanded] = useState(false); 

  const profileData = [
    { name: 'IA Profile', value: profileCounts.iaProfile },
    { name: 'IA Training', value: trainingCounts.iaTraining },
    { name: 'NIS', value: nisCounts.nis },
    
  ];
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setBackgroundIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const handleBarClick = (data) => {
 
    setShowIAProfiling(false);
    setShowIATraining(false);
    setShowIMTContract(false);
  
    switch (data.name) {
      case 'IA Profile':
        setShowIAProfiling(true);
        break;
      case 'IA Training':
        setShowIATraining(true);
        break;
      case 'IMT Contract':
        setShowIMTContract(true);
        break;
      default:
        break;
    }
  };
  
  const getIcon = (item) => {
    switch (item) {
      case 'Farmers':
        return { icon: <FaUser color="#2e7d32" size={28} />, color: 'rgba(46, 125, 50, 0.13)' };
      case 'Projects':
        return { icon: <FaProjectDiagram color="#1976d2" size={28} />, color: 'rgba(25, 118, 210, 0.13)' };
      case 'Masterlist':
        return { icon: <FaListAlt color="#f57c00" size={28} />, color: 'rgba(245, 124, 0, 0.13)' };
      case 'Land Area':
        return { icon: <FaRulerCombined color="#00838f" size={28} />, color: 'rgba(0, 131, 143, 0.13)' };
      
      default:
        return { icon: null, color: undefined };
    }
  };
  
  const formItems = [
    'Farmers',
    'Projects',
    'Masterlist',
    'Land Area' 
  ];
  
  const handleInfoClick = (item) => {
    switch (item) {
      case 'Farmers':
        setInfoTitle('Farmers Count Explained');
        setInfoDescription('The Farmers count you see on your dashboard is the number of farmers ongoing for May. This reflects only those actively participating or registered for current initiatives.');
        break;
      case 'Projects':
        setInfoTitle('Projects Count Explained');
        setInfoDescription('Projects refers to ongoing or completed initiatives under the irrigation authority. It includes infrastructure, training, and support efforts.');
        break;
      case 'Masterlist':
        setInfoTitle('Masterlist Explained');
        setInfoDescription('Masterlist includes all registered farmers, their affiliations, and land data compiled by the system.');
        break;
      case 'Land Area':
        setInfoTitle('Land Area Explained');
        setInfoDescription('Land Area refers to the total irrigated or planned-to-irrigate hectares monitored under your IA jurisdiction.');
        break;
      default:
        setInfoTitle('');
        setInfoDescription('');
    }
    setShowInfoModal(true);
  };

  
  return (
    <Container isExpanded={isSidebarExpanded}>
      <FormsSection>
      {formItems.map((item, index) => {
        const { icon, color } = getIcon(item);
        return (
          <FormCard key={index}>
            <LeftSection>
              <IconCircle color={color}>{icon}</IconCircle>
              <div>
                <Label>{item}</Label>
                <Count>0</Count>
              </div>
            </LeftSection>
            <InfoIcon onClick={e => { e.stopPropagation(); handleInfoClick(item); }} />
          </FormCard>
        );
      })}

      </FormsSection>
      <ContentWrapper isExpanded={isSidebarExpanded}>
      <MainSection>
      <Dashboard profileData={profileData} bgImage={images[backgroundIndex]} onBarClick={handleBarClick} />
     
        

      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <WeatherWrapper>
          <Weather />
        </WeatherWrapper>

      </div>
      
      </MainSection>
      
      </ContentWrapper>


      {showIAProfiling && <IAProfiling setShowIAProfiling={setShowIAProfiling} />}
      {showIATraining && <IATraining setShowIATraining={setShowIATraining} />}
      {showIMTContract && <div>IMT Component Placeholder</div>} 

      {showInfoModal && (
    <ModalOverlay onClick={() => setShowInfoModal(false)}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <h2>{infoTitle}</h2>
        <p>{infoDescription}</p>
        <CloseButton onClick={() => setShowInfoModal(false)}>OK</CloseButton>
      </ModalContent>
    </ModalOverlay>
  )}

    </Container>
  );
};

export default HomeNoso;

const Container = styled.div`
  display: flex;
  margin-left: ${({ isExpanded }) => (isExpanded ? '1110px' : '0px')};
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  background: #f3eded;
`;

const ContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  
  gap: 60px;
  padding: 10px;
  margin-top: -40px;
  margin-left:  0px;
  padding-top: 0;
`;

const MainSection = styled.div`
  display: flex;
  flex-grow: 1;               
  justify-content: space-between;
  align-items: flex-start;     /* Align items to the top (optional) */
  width: 100%;
  gap: 20px;  
  
   @media (max-width: 768px) {
    grid-template-columns: 1fr; 
  }
`;

const WeatherWrapper = styled.div`
  width: 300px;   /* Fixed width for the Weather component */
  min-width: 250px; /* Ensures the weather widget doesn't shrink too much */
`;

const FarmerSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 20px;
`;


const FormsSection = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  padding: 10px 20px;
  margin: 40px ;
  margin-top: 25px;
  paddig-top: 10px
`;

const FormCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 280px;
  height: 60px;
  padding: 0 14px 0 10px;
  background: #f8fcf7;
  border-radius: 14px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  border-left: 5px solid #388e3c;
  margin: 0 10px 10px 0;
  transition: box-shadow 0.2s, transform 0.2s;
  &:hover {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 24px rgba(56,142,60,0.18);
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Label = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: #3a3a3a;
`;

const Count = styled.div`
  font-size: 1.3rem;
  font-weight: 700;
  color: #2e7d32;
  margin-top: 1px;
`;

const InfoIcon = styled(FaInfoCircle)`
  position: absolute;
  top: 8px;
  right: 8px;
  color: #999;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContent = styled.div`
 background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};
  padding: 10px;
  color: #333;
  border-radius: 15px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  animation: fadeInModal 0.3s ease;

  @keyframes fadeInModal {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const CloseButton = styled.button`
  margin-top: 20px;
  background: #4caf50;
  border: none;
  color: white;
  padding: 10px 25px;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #388e3c;
  }
`;

const IconCircle = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ color }) => color || 'rgba(46, 125, 50, 0.15)'};
  margin-right: 10px;
`;
